import { useNavigate } from '@tanstack/react-router'
import { ChevronLeft, Rocket } from 'lucide-react'
import { AgentsLayout } from '@/components/AgentList'
import { PipelineLanes } from '@/components/Pipeline'
import { Empty, IconButton } from '@/components/ui'
import { useFactory } from '@/kinds/agentrun/components'

// The Pipeline screen (/agents/pipeline, 2026-10-16): every change from a ready
// pull request to prod, lane by lane (components/Pipeline.tsx). Part of the
// Agents app: its top bar is the agent pages' (back to every agent on a phone),
// with Releases one tap away.

export const PipelineView = () => {
  const navigate = useNavigate()
  // until /api/config answers the lanes' own Skeleton shows, never a flash of "not set up"
  const factory = useFactory()
  return (
    <AgentsLayout currentId="pipeline">
      <div data-testid="pipeline-view">
        <header
          className="glass-bar sticky top-0 z-20 -mx-3 px-3 pb-2 mb-4 bg-ink border-b border-line/60"
          style={{
            paddingTop: 'calc(env(safe-area-inset-top) + 0.5rem)',
            marginTop: 'calc(-1 * (env(safe-area-inset-top) + 0.5rem))',
          }}
          data-testid="pipeline-topbar"
        >
          <div className="flex items-center gap-1 min-h-11">
            <span className="lg:hidden -ml-2">
              <IconButton label="All agents" onClick={() => void navigate({ to: '/agents/all' })}>
                <ChevronLeft size={20} aria-hidden />
              </IconButton>
            </span>
            <h1 className="flex-1 min-w-0 text-[17px] font-semibold tracking-tight leading-snug truncate">
              Pipeline
            </h1>
            <IconButton label="Releases" onClick={() => void navigate({ to: '/dev/releases' })}>
              <Rocket size={18} aria-hidden />
            </IconButton>
          </div>
        </header>
        {factory.on || !factory.known ? (
          <PipelineLanes />
        ) : (
          <Empty>The software factory is not set up on this server.</Empty>
        )}
      </div>
    </AgentsLayout>
  )
}
